import { css } from 'styled-components';
import { createMuiTheme } from '@material-ui/core/styles';

export const normalTransitions = createMuiTheme().transitions;

export const normalAnimations = {
  create: (animation, settings) =>
    css`
      ${animation} ${settings}
    `,
};
